import React, { useState, useEffect } from 'react';

const AppStoreButton: React.FC = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 640);
        };

        handleResize(); // Check on initial render
        window.addEventListener('resize', handleResize); // Add resize listener

        return () => {
            window.removeEventListener('resize', handleResize); // Cleanup
        };
    }, []);

    const handleClick = () => {
        window.open('https://apps.apple.com/us/app/sudoku-vs/id6473940063', '_blank');
    };

    // Dynamic styles based on screen size
    const buttonContainerStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: isMobile ? '6rem' : '7rem', // Adjusted for mobile
        height: isMobile ? '1.75rem' : '2rem', // Adjusted for mobile
        backgroundColor: '#000',
        borderRadius: '0.5rem',
        padding: isMobile ? '0.375rem 0.625rem' : '0.5rem 0.75rem', // Adjusted for mobile
        cursor: 'pointer',
        transition: 'opacity 0.2s',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell",
        userSelect: 'none',
    };

    const appleLogoStyle: React.CSSProperties = {
        width: '1.875rem',
        height: '2.25rem',
        marginRight: '0.5rem',
    };

    const textContainerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
    };

    const topTextStyle: React.CSSProperties = {
        color: '#fff',
        fontSize: '0.5625rem',
        lineHeight: 1,
        letterSpacing: '0.0125rem',
        marginBottom: '0.125rem',
        whiteSpace: 'nowrap',
    };

    const bottomTextStyle: React.CSSProperties = {
        color: '#fff',
        fontSize: isMobile ? '0.875rem' : '1rem', // Adjusted for mobile
        fontWeight: 600,
        letterSpacing: '-0.0125rem',
        lineHeight: 1,
        whiteSpace: 'nowrap',
    };

    return (
        <div style={buttonContainerStyle} onClick={handleClick} role="button">
            <svg viewBox="0 0 24 28" style={appleLogoStyle}>
                <path
                    d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 6.5C12.72 5.12 13.26 3.65 14.04 2.65C14.94 1.64 16.4 1 17.49 1C17.61 2.41 17.06 3.83 16.21 4.74C15.43 5.65 14.13 6.35 13 6.5Z"
                    fill="white"
                />
            </svg>
            <div style={textContainerStyle}>
                <span style={topTextStyle}>Download on the</span>
                <span style={bottomTextStyle}>App Store</span>
            </div>
        </div>
    );
};

export default AppStoreButton;